export default __webpack_public_path__ + "static/media/basic_ux.b6e13d9a.png";